export default __webpack_public_path__ + "static/Ippy-sq-411ad7107b8339bfb0ae944e15c27fe3.png";